import { useEffect } from "react";
import ICONS from "../../../../assets/Icons";
import DataActionField from "../../../_utils/TransactionCommonComponents/DataActionField";
import SVGComponent from "../../../_utils/SVGComponent";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";

const InternalTxnRecreateAdditionalDetails = ({
  refactorTxnData,
  txnPayLoad,
  setRefactorCopyAmt,
  initialRefactorAdditionalDetail,
  setAdditionalData,
  additionalData,
  setQuantity,
  setInitialRefactorAdditionalDetail,
  setSelectedValue,
  setStartDateCal,
  setSelectedValueMonth,
  setStartDate,
  setEndDate,
  setTimeData,
  setAutoFill,
  onCopyLabels,
}) => {
  const prevLabels = refactorTxnData?.labels || [];

  const labelsCopied =
    initialRefactorAdditionalDetail?.["__labels__"]?.isCopyDirect;

  const displayLabels = prevLabels.length ? prevLabels.join(", ") : "No Labels";

  useEffect(() => {
    if (Number(refactorTxnData?.amount) === Number(txnPayLoad?.amount)) {
      setRefactorCopyAmt(true);
    } else {
      setRefactorCopyAmt(false);
    }
  }, [txnPayLoad.amount]);

  useEffect(() => {
    Object.keys(additionalData).forEach((key) => {
      if (additionalData[key]?.hasOwnProperty("to")) {
        if (
          initialRefactorAdditionalDetail.hasOwnProperty(key) &&
          additionalData[key]?.to ===
            initialRefactorAdditionalDetail[key]?.data?.to &&
          additionalData[key]?.from ===
            initialRefactorAdditionalDetail[key]?.data?.from
        ) {
          setInitialRefactorAdditionalDetail((prev) => ({
            ...prev,
            [key]: {
              ...prev[key],
              isCopyDirect: true,
            },
          }));
        } else {
          setInitialRefactorAdditionalDetail((prev) => ({
            ...prev,
            [key]: {
              ...prev[key],
              isCopyDirect: false,
            },
          }));
        }
      } else if (Array.isArray(additionalData[key])) {
        if (
          !initialRefactorAdditionalDetail.hasOwnProperty(key) ||
          !Array.isArray(initialRefactorAdditionalDetail[key]?.data)
        ) {
          setInitialRefactorAdditionalDetail((prev) => ({
            ...prev,
            [key]: {
              ...prev[key],
              isCopyDirect: false,
            },
          }));
          return;
        }
        let sort1 = [...additionalData[key]].sort((a, b) => a - b);
        let sort2 = [...initialRefactorAdditionalDetail[key]?.data].sort(
          (a, b) => a - b,
        );

        if (sort1?.length === sort2?.length) {
          let result = sort1?.every((item, index) => {
            return item === sort2[index];
          });
          setInitialRefactorAdditionalDetail((prev) => ({
            ...prev,
            [key]: {
              ...prev[key],
              isCopyDirect: result,
            },
          }));
        } else {
          setInitialRefactorAdditionalDetail((prev) => ({
            ...prev,
            [key]: {
              ...prev[key],
              isCopyDirect: false,
            },
          }));
        }
      } else if (additionalData[key]?.hasOwnProperty("start_date")) {
        if (
          initialRefactorAdditionalDetail.hasOwnProperty(key) &&
          additionalData[key]?.end_date ===
            initialRefactorAdditionalDetail[key]?.data?.end_date &&
          additionalData[key]?.start_date ===
            initialRefactorAdditionalDetail[key]?.data?.start_date
        ) {
          setInitialRefactorAdditionalDetail((prev) => ({
            ...prev,
            [key]: {
              ...prev[key],
              isCopyDirect: true,
              isPaste: {},
            },
          }));
        } else {
          setInitialRefactorAdditionalDetail((prev) => ({
            ...prev,
            [key]: {
              ...prev[key],
              isCopyDirect: false,
            },
          }));
        }
      } else {
        if (
          initialRefactorAdditionalDetail.hasOwnProperty(key) &&
          additionalData[key] === initialRefactorAdditionalDetail[key]?.data
        ) {
          setInitialRefactorAdditionalDetail((prev) => ({
            ...prev,
            [key]: {
              ...prev[key],
              isCopyClick: true,
              isCopyDirect: true,
            },
          }));
        } else {
          setInitialRefactorAdditionalDetail((prev) => ({
            ...prev,
            [key]: {
              ...prev[key],
              isCopyClick: false,
              isCopyDirect: false,
            },
          }));
        }
      }
    });
  }, [txnPayLoad?.mergeCategory]);

  // Add txnPayLoad to props destructuring

  useEffect(() => {
    if (!initialRefactorAdditionalDetail?.["__labels__"]?.isCopyDirect) return;

    const prevLabels = [...(refactorTxnData?.labels || [])].sort();
    const currentLabels = [
      ...(txnPayLoad?.labels || []),
      ...(txnPayLoad?.ownerlabels || []),
    ].sort();

    const stillMatches =
      prevLabels.length === currentLabels.length &&
      prevLabels.every((l, i) => l === currentLabels[i]);

    if (!stillMatches) {
      setInitialRefactorAdditionalDetail((prev) => ({
        ...prev,
        ["__labels__"]: {
          ...prev["__labels__"],
          isCopyDirect: false,
        },
      }));
    }
  }, [txnPayLoad?.labels, txnPayLoad?.ownerlabels]);

  const handleInputChange = (e, data_type) => {
    if (data_type === "numeric" && e.target.value.length > 15) {
      return;
    }
    if (e.preventDefault) e.preventDefault();
    const { name, value, data_typeChan } = e.target || {
      name: e.name,
      value: e.value,
    };

    const field = txnPayLoad?.selectedCategory?.configuration?.data?.find(
      (field) => field.name === name,
    );

    let updatedData = { ...additionalData };

    const trimmedValue =
      data_typeChan === "date" ||
      data_typeChan === "year" ||
      data_typeChan === "toggle" ||
      data_typeChan === "time" ||
      data_typeChan === "quantity" ||
      data_typeChan === "from_year_to_year" ||
      data_typeChan === "month_year" ||
      data_typeChan === "date_range" ||
      data_typeChan === "multi_select_list" ||
      data_typeChan === "upload"
        ? value
        : value.replace(/^\s+/, "");

    if (field?.data_type === "numeric") {
      if (trimmedValue === "" || /^\d+$/.test(trimmedValue)) {
        updatedData[name] = trimmedValue;
        setAdditionalData(updatedData);

        if (trimmedValue === "") {
          setInitialRefactorAdditionalDetail((prev) => ({
            ...prev,
            [name]: {
              ...prev[name],
              isCopyDirect: false,
              isCopyClick: false,
              isPaste: {},
            },
          }));
        }
      }
    } else {
      updatedData[name] = trimmedValue;
      setAdditionalData(updatedData);

      if (
        trimmedValue === "" ||
        (Array.isArray(trimmedValue) &&
          trimmedValue.length === GlobalConfiguration.lengthCheckZero)
      ) {
        setInitialRefactorAdditionalDetail((prev) => ({
          ...prev,
          [name]: {
            ...prev[name],
            isCopyDirect: false,
            isCopyClick: false,
            isPaste: {},
          },
        }));
      }
    }
  };

  console.log(refactorTxnData, "refactorTxnData");
  return (
    <main className="flex flex-col lg:flex-row gap-gap-md bg-primary-bg Qsmd:bg-primary-card h-screen lg:h-full w-width-full fixed Qsmd:z-z-index-content z-z-index-header Qsmd:relative top-top-base left-left-base mt-margin-base Qsmd:h-full">
      <div className="h-mobile-create-header flex w-width-full bg-primary-nav Qmd:hidden">
        <div className="p-padding-md Qmd:p-padding-base">
          <div
            className="flex flex-shrink-0 cursor-pointer"
            onClick={() => {
              setAutoFill(false);
            }}
          >
            <SVGComponent
              url={ICONS?.ARROW_LEFT_WHITE}
              color="var(--text-primary)"
              height={"var(--icon-sm)"}
              width={"var(--icon-sm)"}
              alt="Arrow right"
            />
          </div>
        </div>
        <div className="flex flex-col w-width-full py-padding-sm">
          <div className="text-text-primary text-font-md">
            Create transaction
          </div>
          <p className=" text-text-primary text-xs font-semibold">
            Previous transaction details
          </p>
        </div>
      </div>
      <div className="h-full lg:flex-1 Qsmd:max-h-half-screen-height flex flex-col lg:flex-row gap-gap-md lg:gap-gap-base overflow-y-auto">
        <section className="w-width-full lg:w-width-md flex flex-col gap-gap-sm pl-padding-md Qsmd:pl-padding-base pr-padding-md lg:pr-padding-lg Qsmd:mt-margin-md">
          <p className="text-font-md font-semibold text-text-primary whitespace-nowrap mb-margin-sm">
            Additional Details
          </p>

          {refactorTxnData?.additional_data?.data?.filter(
            (data) => data?.data_type !== "upload",
          )?.length ? (
            refactorTxnData?.additional_data?.data
              ?.filter((data) => data?.data_type !== "upload")
              ?.map((details, index) => {
                const hasData =
                  details?.value !== null &&
                  details?.value !== undefined &&
                  !(
                    typeof details?.value === "string" &&
                    details.value.trim() === ""
                  ) &&
                  !(
                    Array.isArray(details?.value) && details.value.length === 0
                  ) &&
                  !(
                    typeof details?.value === "object" &&
                    !Array.isArray(details.value) &&
                    Object.values(details.value || {}).every(
                      (v) => v === null || v === undefined || v === "",
                    )
                  );

                const isSimpleType =
                  details?.data_type === "hyperlink" ||
                  details?.data_type === "string" ||
                  details?.data_type === "numeric";

                const displayValue = !hasData
                  ? "No Data"
                  : typeof details?.value === "boolean"
                    ? JSON.stringify(details?.value)
                    : typeof details?.value === "object"
                      ? details?.data_type === "from_year_to_year"
                        ? `${details?.value?.from} / ${details?.value?.to}`
                        : details?.data_type === "date_range"
                          ? `${details?.value?.start_date} - ${details?.value?.end_date}`
                          : details?.value?.map(
                              (val, i) =>
                                `${val}${details?.value?.length - 1 === i ? "" : ", "}`,
                            )
                      : details?.value === undefined
                        ? "No Data"
                        : details?.value;

                const isCopied = isSimpleType
                  ? initialRefactorAdditionalDetail?.[details?.name]
                      ?.isCopyClick
                  : initialRefactorAdditionalDetail?.[details?.name]
                      ?.isCopyDirect;

                const icon = isSimpleType
                  ? isCopied
                    ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                    : ICONS?.COPY
                  : isCopied
                    ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                    : ICONS?.AUTOFILL_WHITE;

                const hoverEnabled =
                  icon === ICONS?.COPY || icon === ICONS?.AUTOFILL_WHITE;

                return (
                  <div
                    key={`${index}-additional-data`}
                    className="w-full flex flex-col gap-gap-xs"
                    style={{
                      opacity:
                        refactorTxnData?.category !==
                        txnPayLoad?.selectedCategory?.name
                          ? "var(--light-opacity)"
                          : "var(--base-opacity)",
                    }}
                  >
                    <DataActionField
                      subLabel={details?.name}
                      value={displayValue}
                      icon={icon}
                      hoverEnabled={hoverEnabled}
                      disabled={!hasData}
                      onClick={() => {
                        console.log(
                          initialRefactorAdditionalDetail?.[details.name]
                            ?.isPaste,
                        );
                        if (isSimpleType) {
                          let copy = { ...details };

                          if (details?.data_type === "numeric") {
                            copy.value = String(copy?.value);
                          }

                          setInitialRefactorAdditionalDetail((prev) => ({
                            ...prev,
                            [details?.name]: {
                              ...prev[details?.name],
                              isCopyClick: true,
                              isPaste:
                                details?.data_type === "numeric"
                                  ? copy
                                  : details,
                            },
                          }));
                        } else {
                          setInitialRefactorAdditionalDetail((prev) => ({
                            ...prev,
                            [details?.name]: {
                              ...prev[details?.name],
                              isCopyDirect: true,
                            },
                          }));

                          // SAME LOGIC
                          if (details?.data_type === "quantity") {
                            setQuantity((prev) => ({
                              ...prev,
                              [`${details.name}_${details.data_type}`]:
                                details?.value,
                            }));
                          } else if (
                            details?.data_type === "from_year_to_year"
                          ) {
                            setSelectedValue((prev) => ({
                              ...prev,
                              [`${details.name}_${details.data_type}`]:
                                details?.value,
                            }));
                          } else if (details?.data_type === "date") {
                            setStartDate((prev) => ({
                              ...prev,
                              [`${details.name}_${details.data_type}`]:
                                new Date(details?.value),
                            }));
                          } else if (details?.data_type === "month_year") {
                            const [month, year] = details?.value
                              .split("/")
                              .map(Number);

                            const monthNames = [
                              "January",
                              "February",
                              "March",
                              "April",
                              "May",
                              "June",
                              "July",
                              "August",
                              "September",
                              "October",
                              "November",
                              "December",
                            ];

                            setSelectedValueMonth((prev) => ({
                              ...prev,
                              [`${details.name}_${details.data_type}`]: {
                                month: monthNames[month - 1],
                                year,
                              },
                            }));
                          } else if (details?.data_type === "date_range") {
                            const parse = (d) => {
                              if (!d) return null;
                              // Try "DD/MM/YYYY" format
                              if (d.includes("/")) {
                                const [day, month, year] = d
                                  .split("/")
                                  .map(Number);
                                return new Date(year, month - 1, day);
                              }
                              // Try "D MMM, YYYY" format e.g. "5 Jan, 2024"
                              const parsed = new Date(d);
                              return isNaN(parsed.getTime()) ? null : parsed;
                            };

                            const startVal = parse(details?.value?.start_date);
                            const endVal = parse(details?.value?.end_date);

                            if (startVal) {
                              setStartDate((prev) => ({
                                ...prev,
                                [`${details.name}_${details.data_type}`]:
                                  startVal,
                              }));
                            }

                            if (endVal) {
                              setEndDate((prev) => ({
                                ...prev,
                                [`${details.name}_${details.data_type}`]:
                                  endVal,
                              }));
                            }
                          } else if (details?.data_type === "time") {
                            const [time, meridiems] = details?.value
                              .trim()
                              .split(" ");
                            const [hours, minutes] = time.split(":");

                            setTimeData((prev) => ({
                              ...prev,
                              [`${details.name}_${details.data_type}`]: {
                                hours,
                                minutes,
                                meridiems,
                              },
                            }));
                          }

                          handleInputChange({
                            target: {
                              name: details?.name,
                              value: details?.value,
                              data_typeChan: details?.data_type,
                            },
                          });
                        }
                      }}
                    />
                  </div>
                );
              })
          ) : (
            <div className="text-left text-text-primary text-sm antialiased">
              Additional details are not supported for the selected category.
            </div>
          )}

          <div className="invisible hidden lg:flex leading-[var(--icon-xs)]">
            Don't remove this div
          </div>
        </section>
        <div className="w-width-full lg:w-width-md lg:mt-margin-md pl-padding-md Qsmd:pl-padding-base pr-padding-md mb-margin-md lg:mb-margin-base lg:pl-padding-sm">
          <p className="text-font-md font-semibold text-text-primary whitespace-nowrap mb-margin-md">
            Labels (Optional)
          </p>
          <div
            className="w-full flex flex-col gap-gap-xs"
            style={{
              opacity: prevLabels.length
                ? "var(--base-opacity)"
                : "var(--light-opacity)",
            }}
          >
            <DataActionField
              // subLabel="Labels"
              value={displayLabels}
              icon={
                labelsCopied
                  ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                  : ICONS?.AUTOFILL_WHITE
              }
              hoverEnabled={!labelsCopied}
              disabled={!prevLabels.length}
              onClick={() => {
                if (!prevLabels.length) return;

                setInitialRefactorAdditionalDetail((prev) => ({
                  ...prev,
                  ["__labels__"]: {
                    isCopyDirect: true,
                    data: prevLabels,
                  },
                }));

                onCopyLabels(prevLabels); // fires up to parent
              }}
            />
          </div>
          <div className="invisible hidden lg:flex leading-[var(--icon-xs)]">
            Don't remove this div
          </div>
        </div>
      </div>
    </main>
  );
};

export default InternalTxnRecreateAdditionalDetails;
